import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import logo from 'style/imgs/logo.svg';

const Logo: React.FC = () => {
  const history = useHistory();

  const isLogoVisible = useMemo(
    () =>
      !['/dashboard/scholars', '/dashboard/account-settings'].includes(
        history.location.pathname
      ),
    [history.location.pathname]
  );

  if (!isLogoVisible) {
    return <div />;
  }

  return (
    <div className="logo">
      <div>
        <img src={logo} alt="ANETA" />
      </div>
    </div>
  );
};

export default Logo;
